import createHistory from 'history/createBrowserHistory'

const history = createHistory()

export default history



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/history.ts